import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ZefForm, ZefFormsManagerService } from '@zerops/zef/forms';
import { setErrors } from 'ngrx-forms';
import { AppState } from '@zerops/zerops/app';
import { FEATURE_NAME } from './sudo-reauth.constant';

export interface SudoReauthFormValue {
  authMethod: 'password' | 'totp' | 'recovery' | 'webauthn';
  password: string;
  totpCode: string;
  recoveryCode: string;
}

@Injectable({ providedIn: 'root' })
export class SudoReauthForm extends ZefForm<SudoReauthFormValue> {
  constructor(
    public store: Store<AppState>,
    public formsManager: ZefFormsManagerService
  ) {
    super(
      store,
      formsManager,
      FEATURE_NAME,
      {
        authMethod: 'password',
        password: '',
        totpCode: '',
        recoveryCode: ''
      },
      {
        password: (s, ps) => {
          // Guard against null parent state during update cycles
          if (!ps?.controls) {
            return s;
          }

          // Only validate if password method is selected
          if (ps.controls.authMethod.value !== 'password') {
            return setErrors(s, {});
          }

          // Password can be empty, but if provided must be at least 8 characters
          if (s.value && s.value.length > 0 && s.value.length < 8) {
            return setErrors(s, {
              minLength: {
                minLength: 8,
                value: s.value,
                actualLength: s.value.length
              }
            });
          }
          return setErrors(s, {});
        },
        totpCode: (s, ps) => {
          // Guard against null parent state during update cycles
          if (!ps?.controls) {
            return s;
          }

          // Only validate if TOTP method is selected
          if (ps.controls.authMethod.value !== 'totp') {
            return setErrors(s, {});
          }

          // TOTP code can be empty, but if provided must be exactly 6 digits
          if (s.value && s.value.length > 0 && !/^\d{6}$/.test(s.value)) {
            return setErrors(s, {
              pattern: {
                pattern: '6 digits',
                actual: s.value
              }
            });
          }
          return setErrors(s, {});
        },
        recoveryCode: (s, ps) => {
          // Guard against null parent state during update cycles
          if (!ps?.controls) {
            return s;
          }

          // Only validate if recovery method is selected
          if (ps.controls.authMethod.value !== 'recovery') {
            return setErrors(s, {});
          }

          // Recovery code can be empty, but if provided must be exactly 10 characters
          if (s.value && s.value.length > 0 && s.value.length !== 10) {
            return setErrors(s, {
              length: {
                requiredLength: 10,
                actualLength: s.value.length
              }
            });
          }
          return setErrors(s, {});
        }
      }
    );
  }
}
